@for(measure of legacyMeasurementResults; track measure.id) {
    <div>{{formatLegacyMeasurement(measure)}}</div>
    @if(measure?.result?.objectDistance){
      <div>{{'imageRemeasurementEdit.objectDistance' | translate}} {{measure.result.objectDistance}} {{measure?.unit}}</div>
    }
}

@for (measure of merryMeasurementResults(); track $index) {
  @let isAreaBased = measure.type === MeasurementType.AREA || measure.type === MeasurementType.TIP_DEFECT;
  @let measurementValue = isAreaBased ? measure.parameters.area : measure.parameters.length;
  @let unitType = isAreaBased ? "area" : "length";

  <div class="measure-info">
    <span>{{ "measurement." + measure.type | translate }}:</span>
    <div>
      {{ measurementValue | convert : unitSystem : (isAreaBased ? "area" : null) | number : precision() }}
      <span>{{ getUnitLabel(unitType) }}</span>
    </div>
  </div>
}
